import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { useEntity } from '@shapeable/ui';
import { VideoBannerLayout } from './video-banner-layout';
import { classNames } from '@shapeable/utils';
import { Video } from '@shapeable/kelp-forest-alliance-types';

const cls = classNames('video-layout');

// -------- Types -------->

export type VideoLayoutProps = Classable & HasChildren & {
  entity?: Video;
};

export const VideoLayoutDefaultProps: Omit<VideoLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

// -------- Components -------->

const My = {
  Layout: styled(VideoBannerLayout)<ContainerProps>`${ContainerStyles}`,
};

export const VideoLayout: Shapeable.FC<VideoLayoutProps> = (props) => {
  const { className } = props;
  const entity = useEntity(props.entity);

  return (
    <My.Layout className={cls.name(className)} entity={entity} />
  );
};

VideoLayout.defaultProps = VideoLayoutDefaultProps;
VideoLayout.cls = cls;
